import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DashboardLayout from "../../components/SharedLayouts/DashboardLayout";
import UserCard from "../../components/cards/UserCard";
import AdminUserIcon from "../../components/Icons/AdminUserIcon";
import CoopTransactionsTable from "../../components/dashboard/coopTransactions/CoopTransactionsTable";
import { getCoopTransactions } from "../../store/actions/coopTransactions/getCoopTransactions";
import { getCoopTransactionsSummary } from "../../store/actions/coopTransactions/getCoopTransactionsSummary";

const formatMoney = (value) =>
  `₦ ${
    value || value === 0 || value === "0"
      ? Number(value).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00"
  }`;

function CoopTransactions() {
  const dispatch = useDispatch();
  const summary = useSelector((state) => state?.coopTransactions?.summary);
  const summaryPending = useSelector(
    (state) => state?.coopTransactions?.summaryPending
  );

  useEffect(() => {
    dispatch(getCoopTransactions());
    dispatch(getCoopTransactionsSummary());
  }, [dispatch]);

  const summaryCards = [
    {
      id: 1,
      icon: <AdminUserIcon />,
      title: "Total Transactions",
      cardValue: summary?.total_count ?? 0,
    },
    {
      id: 2,
      icon: <AdminUserIcon />,
      title: "Delivered",
      cardValue: summary?.delivered_count ?? 0,
    },
    {
      id: 3,
      icon: <AdminUserIcon />,
      title: "Failed",
      cardValue: summary?.failed_count ?? 0,
    },
    {
      id: 4,
      icon: <AdminUserIcon />,
      title: "Total Settled Amount",
      cardValue: formatMoney(summary?.total_settled_amount),
    },
    {
      id: 5,
      icon: <AdminUserIcon />,
      title: "Delivered Amount",
      cardValue: formatMoney(summary?.delivered_amount),
    },
    {
      id: 6,
      icon: <AdminUserIcon />,
      title: "Failed Amount",
      cardValue: formatMoney(summary?.failed_amount),
    },
  ];

  return (
    <DashboardLayout>
      <div className="px-4 lg:px-8">
        <div className="flex items-center mb-6 md:flex-row md:items-center w-full">
          <Link to={"/"}>
            <img src="/Assets/bread.png" alt="" className="w-8 h-8 mr-2" />
          </Link>
          <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
          <div className="font-semibold text-[#475467] text-sm sm:text-base bg-[#F9FAFB] p-1 px-3 rounded-md">
            Coop. Transactions
          </div>
        </div>

        <div>
          <h1 className="mb-6 font-[600] text-2xl">Coop. Transactions</h1>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {summaryCards.map((detail) => (
              <div key={detail.id} className="mb-4 sm:mb-0">
                <UserCard
                  width={"100%"}
                  height={188}
                  loading={summaryPending}
                  icon={detail.icon}
                  title={detail.title}
                  cardValue={detail.cardValue}
                />
              </div>
            ))}
          </div>

          <div className="mt-4">
            <CoopTransactionsTable />
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}

export default CoopTransactions;
